import Vue from 'vue'
import VueRouter from 'vue-router'

import About from '../views/About.vue'
import AboutPgaTournamentPool from '../views/pga/pga-tournament-pool/About.vue'
import AboutNflWeeklyPickem from '../views/nfl/nfl-weekly-pickem/About.vue'
import AboutNflPlayoffConfidencePool from '../views/nfl/nfl-playoff-confidence-pool/About.vue'
import Account from '../views/Account.vue'
import CreatePool from '../views/CreatePool.vue'
import CurrentPools from '../views/CurrentPools.vue'
import FcsPlayoffBracketResults from '../views/fcs/fcs-bracket-challenge/BracketResult.vue'
import FcsBracketChallengeHome from '../views/fcs/fcs-bracket-challenge/Home.vue'
import Home from '../views/Home.vue'
import JoinPool from '../views/JoinPool.vue'
import ManageFcsPlayoffBrackets from '../views/fcs/fcs-bracket-challenge/ManageBrackets.vue'
import ManageFcsBracketChallenge from '../views/fcs/fcs-bracket-challenge/Manage.vue'
import ManagePgaTournamentPool from '../views/pga/pga-tournament-pool/Manage.vue'
import ManagePgaTournamentPoolEntry from '../views/pga/pga-tournament-pool/ManageEntry.vue'
import ManageNflWeeklyPickem from '../views/nfl/nfl-weekly-pickem/Manage.vue'
import ManageNflPlayoffConfidencePool from '../views/nfl/nfl-playoff-confidence-pool/Manage.vue'
import ManageNflPlayoffConfidencePoolEntry from '../views/nfl/nfl-playoff-confidence-pool/ManageEntry.vue'
import ManageNflWeeklyPickemEntry from '../views/nfl/nfl-weekly-pickem/ManageEntry.vue'
import NflPlayoffConfidencePoolHome from '../views/nfl/nfl-playoff-confidence-pool/Home.vue'
import NflWeeklyPickemHome from '../views/nfl/nfl-weekly-pickem/Home.vue'
import NotFound from '../views/NotFound.vue'
import PastPools from '../views/PastPools.vue'
import PgaTournamentPoolHome from '../views/pga/pga-tournament-pool/Home.vue'
import RequestPasswordReset from '../views/RequestPasswordReset.vue'
import ResetPassword from '../views/ResetPassword.vue'
import UpdateNflWeek from '../views/admin/nfl/nfl-week/Update.vue'
import ViewNflWeeklyPickemEntryWeek from '../views/nfl/nfl-weekly-pickem/ViewEntryWeek.vue'
import ViewNflPlayoffConfidencePoolEntry from '../views/nfl/nfl-playoff-confidence-pool/ViewEntry.vue'

import TestComponent from '../views/TestComponent.vue'

Vue.use(VueRouter)

const routes = [
{
    path: '/admin/nfl/nfl-seasons/:seasonId/nfl-weeks/:weekId/update',
    component: UpdateNflWeek,
    name: 'update-nfl-week',
    props: true
  },
  {
    path: '*',
    component: NotFound,
    name: 'not-found'
  },
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '/account/request-reset-password',
    component: RequestPasswordReset,
    name: 'request-password-reset'
  },
  {
    path: '/account/reset-password',
    component: ResetPassword,
    name: 'reset-password'
  },
  {
    path: '/pools/current',
    component: CurrentPools,
    name: 'current-pools'
  },
  {
    path:'/pools/join',
    component: JoinPool,
    name: 'join-pool'
  },
  {
    path: '/pools/create',
    component: CreatePool,
    name: 'create-pool'
  },
  {
    path: '/pools/past',
    component: PastPools,
    name: 'past-pools',
  },
  {
    path: '/account',
    component: Account,
    name: 'account',
  },
  {
    path: '/fcs-bracket-challenges/:poolId/manage',
    name: 'manage-fcs-bracket-challenges',
    component: ManageFcsBracketChallenge,
    props: true,
  },
  {
    path: '/fcs-bracket-challenges/:poolId',
    name: 'fcs-bracket-challenges',
    component: FcsBracketChallengeHome,
    props: true
  },
  {
    path: '/fcs-bracket-challenges/:poolId/entry/:entryId/brackets/edit',
    name: 'fcs-bracket-challenge-manage-brackets',
    component: ManageFcsPlayoffBrackets,
    props: true,
  },
  {
    path: '/fcs-bracket-challenges/:poolId/entry/:entryId/bracket/:bracketId',
    name: 'fcs-bracket-challenge-bracket-result',
    component: FcsPlayoffBracketResults,
    props: true,
  },
  {
    path: '/pga-tournament-pools/:poolId/manage',
    name: 'manage-pga-tournament-pools',
    component: ManagePgaTournamentPool,
    props: true
  },
  {
    path: '/pga-tournament-pools/:poolId',
    name: 'pga-tournament-pools',
    component: PgaTournamentPoolHome,
    props: true
  },
  {
    path: '/pga-tournament-pools/:poolId/entry/:entryId/edit',
    name: 'pga-tournament-pools-manage-entry',
    component: ManagePgaTournamentPoolEntry,
    props: true
  },
  {
    path: '/pga-tournament-tiers/about',
    name: 'about-pga-tournament-pools',
    component: AboutPgaTournamentPool
  },
  {
    path: '/nfl-weekly-pickems/:poolId/manage',
    name: 'manage-nfl-weekly-pickems',
    component: ManageNflWeeklyPickem,
    props: true,
  },
  {
    path: '/nfl-weekly-pickems/:poolId',
    name: 'nfl-weekly-pickems',
    component: NflWeeklyPickemHome,
    props: true,
  },
  {
    path: '/nfl-weekly-pickems/:poolId/entry/:entryId/week/:weekId/edit',
    name: 'nfl-weekly-pickems-manage-entry',
    component: ManageNflWeeklyPickemEntry,
    props: true,
  },
  {
    path: '/nfl-weekly-pickems/:pickemId/entry/:entryId/week/:weekId',
    name: 'view-nfl-weekly-pickem-entry-week',
    component: ViewNflWeeklyPickemEntryWeek,
    props: true,
  },
  {
    path: '/nfl-weekly-pickems/about',
    name: 'about-nfl-weekly-pickems',
    component: AboutNflWeeklyPickem
  },
  {
    path: '/nfl-playoff-confidence-pools/:poolId/manage',
    name: 'manage-nfl-playoff-confidence-pools',
    component: ManageNflPlayoffConfidencePool,
    props: true,
  },
  {
    path: '/nfl-playoff-confidence-pools/:poolId',
    name: 'nfl-playoff-confidence-pools',
    component: NflPlayoffConfidencePoolHome,
    props: true,
  },
  {
    path: '/nfl-playoff-confidence-pools/:poolId/entry/:entryId/edit',
    name: 'nfl-playoff-confidence-pools-manage-entry',
    component: ManageNflPlayoffConfidencePoolEntry,
    props: true,
  },
  {
    path: '/nfl-playoff-confidence-pools/:poolId/entry/:entryId',
    name: 'view-nfl-playoff-confidence-pool-entry',
    component: ViewNflPlayoffConfidencePoolEntry,
    props: true,
  },
  {
    path: '/nfl-playoff-confidence-pools/about',
    name: 'about-nfl-playoff-confidence-pools',
    component: AboutNflPlayoffConfidencePool
  },
  {
    path: '/test',
    name: 'test',
    component: TestComponent
  }
]

const router = new VueRouter({
  routes
})

export default router
